// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.axis_Yf0g1 {
  position: relative;
  height: 18px;
}

.tick_X30Xt, .subTick_uKtJj {
  position: absolute;
  white-space: nowrap;
}

.tick_X30Xt {
  transform: translateX(-50%);
}

.subTick_uKtJj {
  width: 10px;
  transform: translateX(-5px);
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/dataViewers/timeline/TimelineAxis.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;AACpB","sourcesContent":[".axis {\n  position: relative;\n  height: 18px;\n}\n\n.tick, .subTick {\n  position: absolute;\n  white-space: nowrap;\n}\n\n.tick {\n  transform: translateX(-50%);\n}\n\n.subTick {\n  width: 10px;\n  transform: translateX(-5px);\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"axis": `axis_Yf0g1`,
	"tick": `tick_X30Xt`,
	"subTick": `subTick_uKtJj`
};
export default ___CSS_LOADER_EXPORT___;
